module.exports = __webpack_public_path__ + "assets/img/title.b606106c.jpg";